






















import { Vue, Component } from "@/shared/vuepack";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";

@Component
export default class Footer extends Vue {

  portalCustomizationStore = usePortalCustomizationStore();

  get supportPhone () {
    return this.portalCustomizationStore.supportInfo.supportPhone;
  }

  get supportPhoneFormatted () {
    return `tel:+1-${this.portalCustomizationStore.supportInfo.supportPhone}`;
  }

  get aboutUsUrl () {
    return this.portalCustomizationStore.supportInfo.supportWebsite;
  }

  get supportEmail () {
    return `mailto:${this.portalCustomizationStore.supportInfo.supportEmail}`;
  }

  get supportName () {
    return `${this.portalCustomizationStore.supportInfo.displayName} Customer Support`;
  }
  get hasPartnerSupportEmail (): boolean {
    return this.portalCustomizationStore.hasPartnerSupportEmail;
  }
}
